module.exports = require("/tmp/build_e54bc619/src/lib/gatsby/gatsby-browser.tsx");